export default __webpack_public_path__ + "static/media/Remise_en_selle.564b4505.svg";